module.exports = __webpack_public_path__ + "static/media/profileInactive.14aa9faa.svg";